import { handleTrack } from '../../../utils/tracker';
import { keywordArray } from '../utils/contants';

export const KeywordGrid = (): JSX.Element => {
  return (
    <div className="flex gap-[11px] flex-wrap sm:flex-wrap mt-14 mb-12">
      {keywordArray.map((keyword, index) => {
        let linkKey = keyword;
        if (linkKey === '#') {
          linkKey = 'terms-starting-with-num';
        }
        return (
          <a
            className="text-s-20 flex items-center justify-center font-bold text-grey-970 cursor-pointer rounded-full w-8 h-8 sm:h-5 sm:w-5 sm:text-s-14 transition duration-300 ease-in-out hover:bg-blue-600 hover:text-white"
            key={index}
            href={`/glossary/${linkKey}/index`}
            onClick={(e) => {
              handleTrack({
                label: `index_keyword`,
                obj: e.target,
              });
            }}
          >
            {keyword}
          </a>
        );
      })}
    </div>
  );
};
